module.exports = __webpack_public_path__ + "img/my-players.e48fc3a8.png";